import request from '@/utils/request'
import requestFee from '@/utils/request-no-toast'
import { Message } from 'element-ui'
import { workOrderApiParamsVerify } from '@/utils/regular'

// 强制分配工单
export function getUserList(params) {
  return request({
    url: '/admin/v1/workOrderGroupUserRelation/getUsers',
    method: 'get',
    params
  })
}

export function getWorkOrderList(params) {
  // 判断orderId、workId参数是否正确
  if (workOrderApiParamsVerify(params)) { 
    return Promise.reject('入参错误')
  }
  return request({
    url: '/admin/v1/workOrderInfo/list',
    method: 'GET',
    params
  })
}

export function queryWorkOrderCount(params) {
  return request({
    url: '/admin/v1/workOrderInfo/queryCount',
    method: 'GET',
    params
  })
}

// 添加模板
export function addWorkOrder(params) {
  return request({
    url: '/admin/v1/workOrderInfo/insert',
    method: 'post',
    data: params
  })
}
// 强制分配工单
export function forceDistribution(params) {
  return request({
    url: '/admin/v1/workOrderInfo/forceDistribution',
    method: 'put',
    data: params
  })
}
// 获取用户当前上线状态

export function getOnlineStatusByUserId(params) {
  return request({
    url: '/admin/v1/workOrderGroupUserRelation/getOnlineStatusByUserId',
    method: 'get',
    params
  })
}
// 用户上下线
export function updateOnlineStatusByUserId(params) {
  return request({
    url: '/admin/v1/workOrderGroupUserRelation/updateOnlineStatusByUserId',
    method: 'put',
    data: params
  })
}

// 客诉工单详情
export function getworkOrderInfo(params) {
  return request({
    url: '/admin/v1/workOrderInfo/getById?id=3',
    method: 'put',
    data: params
  })
}

// 工单标签树形列表
export function getWorkOrderLabelTree(params) {
  return request({
    url: '/admin/v1/workOrderLabel/tree',
    method: 'get',
    params
  })
}

// 工单标签树形列表
export function getPendingCount(params) {
  return request({
    url: '/admin/v1/workOrderInfo/getPendingCount',
    method: 'get',
    params
  })
}

/**
 * 根据订单ID查询订单类型
 * @param { string | required} params.order_id
 */
export function getOrderByOrderId(params) {
  if (!params?.order_id) {
    Message.error('order_id为必填字段')
    return new Promise(function (resolve, reject) {
      reject()
    })
  }
  // 判断orderId、workId参数是否正确
  if (workOrderApiParamsVerify(params)) { 
    return Promise.reject('入参错误')
  }
  return request({
    url: '/admin/v1/orderInfo/getOrderByOrderId',
    method: 'get',
    params
  })
}

// 获取员工在线时长
export function getTodayOnlineTime(params){
  return request({
    url: '/admin/v1/userStatusRecord/todayOnlineTime',
    method: 'get',
    params
  })
}

// 获取渠道
export function getAgents() {
  return request({
    url: '/admin/v1/paycenter/queryAgents',
    method: 'get',
    data: {}
  })
}

// 新建工单，根据工单标题id获取标题详情
export function getWorkOrderLabel(params) {
  return request({
    url: '/admin/v1/workOrderLabel/getWorkOrderLabel',
    method: 'get',
    params
  })
}

// 司机模糊查询
export function searchDriver(params) {
  return request({
    url: '/admin/v1/search/drivers',
    method: 'get',
    params
  })
}

// 获取司机详细信息
export function getDriverDetails(params){
  return requestFee({
    url: '/admin/v1/third_part/driver/info',
    method: 'get',
    params
  })
}

// 获取工单小结
/**
 * 根据会话ID判断是否创建过工单
 * @param { String } moor_id 会话id
 * @param { Number } type 会话id 1:在线工作台 2:电话进线
 * @param { Boolean } isInit 是否是初始化
 * @return { Boolean } 是否创建过工单
 */
export function getByMoorId(params){
  return requestFee({
    url: '/admin/v1/workOrderInfo/getByMoorId',
    method: 'get',
    params
  })
}

// 是否存在处理中工单
export function getIsExist(params) {
  // 判断orderId、workId参数是否正确
  if (workOrderApiParamsVerify(params)) { 
    return Promise.reject('入参错误')
  }
  return requestFee({
    url: '/admin/v1/workOrderInfo/isExist',
    method: 'get',
    params
  })
}

// 批量添加模板
export function addBatchWorkOrder(data) {
  return request({
    url: '/admin/v1/order/batchInsertWorkorder',
    method: 'post',
    data: data
  })
}


